import { useEffect } from "react";

const SITE = "https://drinkdunc.com";

// Lightweight per-page SEO for the SPA — title, meta description, canonical.
export const usePageMeta = (title, description) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", description);
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute("href", SITE + window.location.pathname);
    }
  }, [title, description]);
};
